
export default function About() {
  return (
    <section id="about" className="py-32 bg-[#FDF8F6]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-12">
          <p className="text-rose-400 text-xs tracking-widest uppercase mb-8">WHO WE ARE</p>
        </div>

        <div className="flex items-start justify-between gap-16">
          <div className="w-[65%]">
            <h2 className="font-serif text-[#3a1a1a] leading-tight mb-20" style={{ fontSize: '72px', lineHeight: '1.3' }}>
              <span>Mount Zion Investment </span>
              <span className="inline-flex items-center mx-2">
                <img
                  src="https://public.readdy.ai/ai/img_res/5183113ee4d4ab3ddd914d41968a9522.jpg"
                  alt="Beauty Products"
                  className="rounded-full object-cover"
                  style={{ width: '120px', height: '72px' }}
                />
              </span>
              <br />
              <span>builds retail stores</span>
              <br />
              <span>that </span>
              <span className="inline-flex items-center mx-2">
                <img
                  src="https://readdy.ai/api/search-image?query=beautiful%20woman%20applying%20makeup%20in%20mirror%20warm%20glowing%20skin%20radiant%20beauty%20natural%20light%20elegant%20feminine%20portrait%20cosmetics%20lifestyle%20photography%20soft%20background&width=120&height=72&seq=about-beauty-001&orientation=landscape"
                  alt="Beauty"
                  className="rounded-full object-cover"
                  style={{ width: '120px', height: '72px' }}
                />
              </span>
              <span> inspire </span>
              <span className="inline-flex items-center mx-1">
                <div className="w-12 h-12 rounded-full bg-rose-400 flex items-center justify-center">
                  <i className="ri-store-3-line text-2xl text-white"></i>
                </div>
              </span>
              <span> beauty</span>
            </h2>

            <div className="flex items-center gap-5">
              <button className="bg-rose-500 text-white px-10 py-3 rounded-full text-sm font-medium hover:bg-rose-600 transition-all whitespace-nowrap cursor-pointer">
                Our Story
              </button>
              <button className="border-2 border-rose-500 text-rose-500 px-10 py-3 rounded-full text-sm font-medium hover:bg-rose-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                View Our Stores
              </button>
            </div>
          </div>

          <div className="w-[35%]">
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              Mount Zion Investment INC is a premier retail store builder specializing in beauty and skincare boutiques. We design, build, and launch stunning retail experiences from the ground up.
            </p>
            <p className="text-gray-700 text-base leading-relaxed">
              From store concept and interior design to product curation and grand opening — our team delivers end-to-end retail solutions that attract customers and drive sales.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
